import React from 'react';
import PropTypes from 'prop-types';

const CostReviewLineItemBody = ({ children = null }) => {
  return <div>{children}</div>;
};

CostReviewLineItemBody.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default CostReviewLineItemBody;
